import React, { useState, useEffect } from "react";
import { Grid, Icon, } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import Button from "../button/Button"
import DeleteConfirmation from "./deleteComfirmationModal";
import { cloneDeep, random } from "lodash";
import MerchandiseLineItem from "../../../../CBP_App/formSections/merchandiseSections/MerchandiseLineItem"
import PGAItem from "../../../../CBP_App/formSections/pga/PGAItem"
import { getHSDtlList, getPGATemplate } from "../../../../CBP_App/api/htsRequests"; 
import { useSelector, useDispatch } from "react-redux"
import { initiate_main_form, update_main_form, initiate_pga_data, update_pga_data, update_repeated_sub_Field, update_repeated_sub_sub_field, update_repeated_field, update_lacey_act_field, update_pga_item_field, 
    initiate_dynamic_pga_data, 
    add_repeated_item,
    remove_repeated_group,
    replace_all_repeated_item_dynamic,
    delete_replace_multiple_PGA_values,
    add_repeated_sub_field_dynamic,
    remove_repeated_sub_group_dynamic} from "../../../../actions/manageProductHistory"
import { convertFDAFOOItems, makeFlatListForPgaItemsForProductHistory, mapFlatListWithAllPgaData } from '../../../../CBP_App/formSections/util/assignValues'
import { getDropdownValues as getDropdownValuesCBP, getCountryList, getSpecialProgramList, getUnitList, getUSStateList } from "./../../../../CBP_App/api/getEntrySummaryData"
import _ from "lodash"
import { getQueryVariable } from "../../../../apiCalls/jobInfo";
import  "../../../../styleSheets/sass/index.scss";
import  "../../../../CBP_App/styleSheets/index.scss";
import  "../../../../CBP_App/styleSheets/theme/_mixins.scss";
import "../../../../CBSA_App/components/entrySummaryForms/css/ISFForm.css";
import { pgaFlagTypeList, pgaHumanNames } from "../../../../CBP_App/formSections/pga/constantsPGA";
import PGAItems from "../../../../CBP_App/formSections/pga/PGAItems";
import { DropDown } from '../../../../commonComponents/dropDownCommon'
import { getTargetPGAForm } from "../../../../CBP_App/api/getEntrySummaryData";
import VoluntryPgas from "./VoluntaryPgas";

const UpdateFormUS = ({ data, updateAPI, deleteAPI, selectedRowMethod, formReset }) => {
    const formData = useSelector((state) => {
        return state.productHistRow
    })
    formData.productClaimCode =  formData.productClaimCode || formData.tradeProgramClaimCode;
    let allPgaData =  useSelector((state) => state.productHistPga);
    const [dropdownValues, setDropdownValuesLocal] = useState({});
    let newFlags = {}
    for(let accct of (allPgaData?.pgaData?.pgaActData||[])){
        newFlags[pgaFlagTypeList[accct.pgaType] || pgaFlagTypeList[accct.pgaType+"_"+accct.pgaType]] = 1;
    }
    allPgaData.pgaFlags = allPgaData.pgaFlags|| newFlags
    const dataAtReset = cloneDeep(formData)
    const [isOpen, setIsOpen] = React.useState(true);
    const [currCountryIndex, setCurrCountryIndex] = useState(0);
    const [currHtsIndex, setCurrHtsIndex] = useState(0);
    const [formOpen, setFormOpen] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);
    const dynamicProps = useSelector((state) => state.dynamicPgaData)
    const [pgaWithoutPgaItems, setPgaWithoutPgaItems] = useState([]);
    const [pgaDataFlag, setPgaDataFlag] = useState(false);
    const [activeAccordianIndex, setActiveAccordianIndex] = React.useState("")
    const [hsDataDtl, setHtsDataDtl] = React.useState({"pgaMetadata": {
        "tarriffPgaDetails": []
    }});
    const [applicableProgramNames, setApplicableProgramNames] = useState([]);
    const [selectedPga, setSelectedPga] = useState({});
    const [pgaDropdownVal, setPgaDropdownVal] = useState({});
    const [formDisabled, setFormDisabled] = useState(false);
    let newFormData = cloneDeep(formData);
    const dispatch = useDispatch();
    const updateFormState = (field, value, level, index) => {
        dispatch(update_main_form(field, value, level, index, "US"));
    }
    let isEngine = getQueryVariable('onlyOneShipment');
    const reset = () => {
        formReset(formData.productLineId, formData.customerId)   
        if(pgaDataFlag)
            setPgaDataFlag(false);
        else
            setPgaDataFlag(true);
        
    }
    // for the exapnsion of the form not the removal of the complete form
    const toggleExpandForm = () => {
        if(isOpen)
        {
            setIsOpen(false)
        }
        else{
            setIsOpen(true);
        }
    }
    // for the closing of the form
    const toggleFormOn = () => {
        if(formOpen)
        {
            setFormOpen(false);
        }
        else
        {
            setFormOpen(true);
        }
    }

    const updatePGAField=(pgaGuid,formType, lineItemIndex, fieldName, value)=>{
        // dispatch(update_pga_data(pgaGuid,formType, lineItemIndex, fieldName, value, "UPDATE_PGA_DATA", isEngine))
        dispatch(update_pga_data(pgaGuid,formType, lineItemIndex, fieldName, value, "UPDATE_DYNAMIC_PGA_DATA", isEngine))
    }
    const savePGAField=(formType, merchandiseId, lineItemIndex, fieldName)=>{
        return;
    }

    const updateMerchLineItemPgaObject = (id, field, payload  , lineItemIndex ,invoiceItemIndex )=>{
        //debugger
    }

    const saveRepeatedSubField = (targetPGA, merchandiseId, lineItemIndex, index, field, list,containerCardinality)=>{
        return;
    }

    const updateRepeatedSubField = (pgaGuid,targetPGA, lineItemIndex, index, field, payload, list,containerCardinality) => {
        // dispatch(update_repeated_sub_Field(pgaGuid,targetPGA, lineItemIndex, index, field, payload, list,containerCardinality, "UPDATE_REPEATED_SUB_FIELD", isEngine))
        dispatch(update_repeated_sub_Field(pgaGuid,targetPGA, lineItemIndex, index, field, payload, list,containerCardinality, "UPDATE_DYNAMIC_REPEATED_SUB_FIELD", isEngine))
        return;
    }

    const saveRepeatedSubSubField = (pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, field, list,containerCardinality,innerContainerCardinality) => {
        return;
    }

    const updateRepeatedSubSubField = (pgaGuid,targetPGA, merchandiseId, index, field, payload, list,containerCardinality,innerContainerCardinality) => {
        // dispatch(update_repeated_sub_sub_field(pgaGuid,targetPGA, merchandiseId, index, field, payload, list,containerCardinality,innerContainerCardinality, "UPDATE_REPEATED_SUB_SUB_FIELD", isEngine))
        dispatch(update_repeated_sub_sub_field(pgaGuid,targetPGA, merchandiseId, index, field, payload, list,containerCardinality,innerContainerCardinality, "UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD", isEngine))
        return;
    }

    const updateRepeatedField=(pgaGuid,targetPGA, merchandiseId, index, field, payload, list) =>{
        //debugger
        // dispatch(update_repeated_field(pgaGuid,targetPGA, merchandiseId, index, field, payload, list, "UPDATE_REPEATED_FIELD", isEngine))
        dispatch(update_repeated_field(pgaGuid,targetPGA, merchandiseId, index, field, payload, list, "UPDATE_DYNAMIC_REPEATED_FIELD", isEngine))
    }
    const removeRepeatedGroup=(pgaGuid, formType, merchandiseId, lineItemIndex, index, list) =>{
        dispatch(remove_repeated_group(pgaGuid, formType, merchandiseId, lineItemIndex, index, list))
        return;
    }
    const addRepeatedItem=(pgaGuid, formType, merchandiseId, lineItemIndex, list)=>{
        dispatch(add_repeated_item(pgaGuid, formType, merchandiseId, lineItemIndex, list, isEngine))
    }
    const removeRepeatedSubGroup=(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, list,containerCardinality)=>{
        dispatch(remove_repeated_sub_group_dynamic(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, list,containerCardinality, isEngine))
    }
    const saveRepeatedField = (targetPGA, merchandiseId, lineItemIndex, index, field, list) => {
        return;
    }
    const updateContainerPGA=(targetPGA, merchandiseId, index, containerNum) =>{
        //debugger
    }
    const addContainerPGA=(targetPGA, merchandiseId)=>{
        return;
    }
    const removeContainerPGA=(formType, merchandiseId, lineItemIndex, index)=>{
        return;
    }
    const saveContainerPGA=(formType, merchandiseId, lineItemIndex, index)=>{
        return;
    }
    
    const saveLaceyActField = (merchandiseId, lineItemIndex, field) => {
        return;
    }

    const updateLaceyActField = (merchandiseId, field, payload) => {
        // dispatch(update_lacey_act_field(merchandiseId, field, payload, "UPDATE_LACEY_ACT_FIELD", isEngine))
        dispatch(update_lacey_act_field(merchandiseId, field, payload, "UPDATE_DYNAMIC_LACEY_FIELD", isEngine))
        return;
    }

    const savePGAItemField = (merchandiseId, lineItemIndex, index, field) => {
        return
    }

    const updatePGAItemField = (lineItemIndex, index, field, payload) => {
        // dispatch(update_pga_item_field(lineItemIndex, index, field, payload, "UPDATE_PGA_ITEM_FIELD", isEngine))
        dispatch(update_pga_item_field(lineItemIndex, index, field, payload, "UPDATE_DYNAMIC_PGA_ITEM_FIELD", isEngine))
        return
    }

    const replaceAllRepeatedItem = (pgaGuid, formType, merchandiseId, lineItemIndex, listType, newList) => {
        dispatch(replace_all_repeated_item_dynamic(pgaGuid, formType, merchandiseId, lineItemIndex, listType, newList, isEngine))
    }
    const deleteAndReplaceMultiplePGAValues = (pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list, newListOfItems,alsoAddThisSave) => {
        dispatch(delete_replace_multiple_PGA_values(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list, newListOfItems,alsoAddThisSave, isEngine))
    }
    const addRepeatedSubField = (pgaGuid, targetPGA, merchandiseId, lineItemIndex, list,containerCardinality,initialValues_th) =>{
        dispatch(add_repeated_sub_field_dynamic(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list,containerCardinality,initialValues_th, isEngine))
    }
    const _setActiveAccordianIndex = (index) => {
        if (index === activeAccordianIndex) {
        setActiveAccordianIndex('')
        } else {
          setActiveAccordianIndex(index)
        }
      }

    const makePgaDropdownValues = (tarriffPgaDetails) => {
        let pgaDropdownVal = {};
        if(tarriffPgaDetails){
            let applicablePrograms = [];
            tarriffPgaDetails.map((pgaDetail, index) => {
                const {programName, programDetails} = pgaDetail;
                if(!applicablePrograms.includes(programName)){
                    applicablePrograms.push(programName);
                }
                pgaDropdownVal[programName] = programDetails.map((programDetail, index) => {
                    const {formType} = programDetail
                    return { description: pgaHumanNames[formType], value: formType}
                })
            })
            setApplicableProgramNames(applicablePrograms);
        }
        setPgaDropdownVal(pgaDropdownVal);
    }

    useEffect(()=>{
        window.addEventListener("message", (event) => {
            if(event.data.callSentToIframe === "setPgaData"){
                let {pga: {pgaData, pgaFlags}, formDisabled} = event.data;
                setFormDisabled(formDisabled);
                let {currCountryIndex, currHtsIndex} = event.data;
                if(pgaData && pgaFlags){
                    let newAllPgaData = {
                        pgaData: JSON.parse(pgaData),
                        pgaFlags: JSON.parse(pgaFlags)
                    }
                    dispatch(initiate_pga_data(newAllPgaData))
                    let newPgaData = JSON.parse(pgaData);
                    let newSelectedPga = {};
                    if(newPgaData.pgaActData){
                        newPgaData.pgaActData.map((item) => {
                            const {pgaProgram, pgaType} = item;
                            newSelectedPga[`${pgaProgram}`] = pgaType;
                        })
                    }
                    setSelectedPga({...selectedPga, ...newSelectedPga})
                }
                
                setCurrCountryIndex(currCountryIndex)
                setCurrHtsIndex(currHtsIndex)
            }
        })
        window.parent.postMessage("partspga-ready", "*");
        
        if(!sessionStorage.getItem("DROPDOWN_VAL")){
            getDropdownValuesCBP().then((response) => {
            })
          }
        let hts = _.get(formData,"merchandiseDuties.duties[0].htsus");
        if(hts){
            getHSDtlList(undefined, undefined, hts,undefined)
            .then((response) => {
                let hsDataDtl = _.get(response, "data.eventMessage", false);
                makePgaDropdownValues(hsDataDtl?.pgaMetadata?.tarriffPgaDetails);
                setHtsDataDtl(hsDataDtl)
            })
        }
        else if(htsFromEngine){
            setTimeout(() => {
                getHSDtlList(undefined, undefined, htsFromEngine,undefined)
                .then((response) => {
                    let hsDataDtl = _.get(response, "data.eventMessage", false);
                    makePgaDropdownValues(hsDataDtl?.pgaMetadata?.tarriffPgaDetails);
                    setHtsDataDtl(hsDataDtl)
                })
            }, 0)
            }
        document.getElementById("form-close") && document.getElementById("form-close").focus();
    }, [])
    useEffect(() => {
        let _dynamicProps = {}
        for(let pgaTypexx of _.uniq((allPgaData?.pgaData?.pgaActData||[]).map(a=>a.pgaType)) ){
            
            let flagName = pgaFlagTypeList[pgaTypexx]
            let flag = camelToSnakeCase(flagName)?.toUpperCase()?.replace("_FLAG", "")
            let pgaData = _.get(allPgaData, "pgaData.pgaActData", []).filter((_item)=>{
                return _item.pgaType == pgaTypexx;
            });


            for (let currentpgaData of pgaData) {
        
                if(!currentpgaData.PGAItems || currentpgaData.PGAItems.length === 0){
                    if(!pgaWithoutPgaItems.includes(currentpgaData.pgaProgram)){
                        setPgaWithoutPgaItems([...pgaWithoutPgaItems, currentpgaData.pgaProgram]);
                    }

                    continue;
                }
                if (!currentpgaData.pgaGuid) {
                    currentpgaData.pgaGuid = "FAKEGUID_"+currentpgaData.pgaType + Math.random();
                }
                
                const dynamicPropsKey= pgaData.length>1?
                    `${currentpgaData.pgaType}_${pgaData.indexOf(currentpgaData)+1}`:
                    currentpgaData.pgaType;

                let flgItem2 = `${pgaTypexx}__#_${currentpgaData.pgaGuid}`
                _dynamicProps[dynamicPropsKey] = {}
                _dynamicProps[dynamicPropsKey][flgItem2] = convertFDAFOOItems(currentpgaData.PGAItems, "merch1",currentpgaData.pgaGuid, flag, currentpgaData?.isManuallyAddedPga);
                _dynamicProps[dynamicPropsKey][flgItem2]["pgaType"] = currentpgaData.pgaType;
            }
            
            
        }
        dispatch(initiate_dynamic_pga_data(_dynamicProps));
    }, [allPgaData])


    const camelToSnakeCase = str => str?.replace(/[A-Z]/g, letter => `_${letter?.toLowerCase()}`);
    let htsFromEngine = getQueryVariable('hts');
    useEffect(() => {
        let dropdownValues = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL")) || {};
        if(!dropdownValues){
            getDropdownValuesCBP().then((response) => {
            })
        }
        if(dropdownValues.eventMessage){
            // let countryList = _.get(JSON.parse(sessionStorage.getItem("COUNTRY_LIST")), "eventMessage.itemList", []);
            let splProgramList = _.get(JSON.parse(sessionStorage.getItem("SPL_PROGRAM")), "eventMessage.itemList", []);
            let unitList = _.get(JSON.parse(sessionStorage.getItem("UNITS_LIST_NEW")), "eventMessage.itemList", []);
            let USStatesList = _.get(JSON.parse(sessionStorage.getItem("PROVINCE_LIST")), "eventMessage.itemList", []);

            dropdownValues.eventMessage.USStatesList = USStatesList;
            dropdownValues.eventMessage.countryList = dropdownValues.eventMessage.countriesList;
            dropdownValues.eventMessage.constituentElemUomList = dropdownValues.eventMessage.constituentElemUom;
            dropdownValues.eventMessage.splProgramList = splProgramList;
            dropdownValues.eventMessage.unitList = unitList;
        setDropdownValuesLocal(dropdownValues);}
    }, [sessionStorage.getItem("SPL_PROGRAM"), sessionStorage.getItem("UNITS_LIST_NEW"), sessionStorage.getItem("COUNTRY_LIST"), sessionStorage.getItem("PROVINCE_LIST")])
    useEffect(()=>{
        const keys = Object.keys(pgaDropdownVal);
        let initialState = {};
        keys.map((key) => {
            initialState[key] = "";
        })
        setSelectedPga({...initialState, ...selectedPga});
    }, [pgaDropdownVal])

    const pgaDropdownOnChange = async ({value, programName, isManuallyAddedPga="false"}) => {
        setSelectedPga({...selectedPga, [`${programName}`]: value})
        const response = await getPGATemplate(value);
        let {data:{eventMessage}} = response;
        eventMessage.pgaType = eventMessage.formType
        let newPgaData = cloneDeep(allPgaData);
        let newPgaFlags = cloneDeep(newPgaData.pgaFlags);
        if(newPgaData?.pgaData){
            let newPgaActData = cloneDeep(newPgaData.pgaData.pgaActData) || [];
            let newIndex = newPgaActData.findIndex((item) => item.pgaProgram===programName);
            if(newIndex !== -1){
                let test = [];
                let pgaTypeToBeRemoved = newPgaActData[newIndex].pgaType
                delete newPgaFlags[pgaFlagTypeList[pgaTypeToBeRemoved]]
                test = newPgaActData.splice(newIndex, 1);
            }
            newPgaActData.push({...eventMessage, PGAItems:eventMessage.pgaItems, isManuallyAddedPga})
            
            newPgaData.pgaData.pgaActData = newPgaActData
        }
        else{
            newPgaData.pgaData={
                pgaActData: [{...eventMessage, PGAItems:eventMessage.pgaItems, isManuallyAddedPga}]
            }
        }
        newPgaFlags[pgaFlagTypeList[value]] = 1;
        newPgaData.pgaFlags = newPgaFlags
        dispatch(initiate_pga_data(newPgaData))
    }

    const deletePga = (pgaGuid)=>{
        let newPgaData = cloneDeep(allPgaData);
        let newPgaFlags = cloneDeep(newPgaData.pgaFlags);
        let newPgaActData = cloneDeep(newPgaData.pgaData.pgaActData);
        let pgaToBeRemoved = newPgaActData.find((item) => item.pgaGuid===pgaGuid);
        let pgaTypeToBeRemoved = pgaToBeRemoved.pgaType;
        let pgaProgramNameToBeRemoved = pgaToBeRemoved.pgaProgram;
        delete newPgaFlags[pgaFlagTypeList[pgaTypeToBeRemoved]]
        let test = [];
        let newIndex = newPgaActData.findIndex((item) => item.pgaGuid===pgaGuid);
        test = newPgaActData.splice(newIndex, 1);
        newPgaData.pgaData.pgaActData = newPgaActData
        newPgaData.pgaFlags = newPgaFlags
        let newSelectedPga = cloneDeep(selectedPga);
        delete newSelectedPga[`${pgaProgramNameToBeRemoved}`];
        setSelectedPga(newSelectedPga);
        dispatch(initiate_pga_data(newPgaData))
    }
    const pgaItemRender = (displayManualPgas=false) => {
                return(allPgaData.pgaFlags && (Object.keys(dynamicProps)).map((item, index)=>{ 
                let pgaDataValues = dynamicProps[item];
                let pgaDataValuesKey = Object.keys(pgaDataValues)[0];
                let pgaType = pgaDataValues[pgaDataValuesKey]["pgaType"];                             
                let FIELD_META = {"disabled": false}
                let displayManualPgasCondition = displayManualPgas===true ? pgaDataValues[pgaDataValuesKey].isManuallyAddedPga : !pgaDataValues[pgaDataValuesKey].isManuallyAddedPga
                if(!_.isEmpty(dynamicProps) && displayManualPgasCondition){
                {
                return (
                    <div key={`pgaFrm-${index}`} className="accordian-section tab-content pga-container FDA_FOO" style={{"marginTop":"5px"}}>
                        <div
                            className='title'
                            onClick={() => {
                                _setActiveAccordianIndex(index)
                            }}
                        >
                            {isEngine && <DeleteConfirmation message={<p>Are you sure you want to delete the item with PGA - GOVT. AGENCY PROGRAM CODE - {item}</p>} icon={"trash alternate"} delAPI={deletePga} productLineId={pgaDataValues[pgaDataValuesKey].pgaGuid} />}
                            {/* <Icon onClick={(e)=>{
                                e.stopPropagation();
                                deletePga(pgaDataValues[pgaDataValuesKey].pgaGuid);
                            }} color="red" name='trash alternate outline'/> */}
                                <span>PGA - GOVT. AGENCY PROGRAM CODE - {item}</span>
                                    <Icon
                                    name={
                                        (activeAccordianIndex === index)
                                        ? 'angle down'
                                        : 'angle right'
                                    }
                                    />
                                </div>
                                    
                            {
                                activeAccordianIndex === index && 
                                <PGAItem
                                launchFrom={"PRODUCT_HISTORY"}
                                lineItemIndex={0}
                                invoiceItemIndex={0}
                                pgaFlag={Object.keys(item)[0]}
                                {...pgaDataValues}
                                merchandiseId={""}
                                modeOfTransport={""}
                                DropDownValues={dropdownValues.eventMessage}
                                open={() => {
                                    //this.getOpenFunction(pga.formType, index)
                                }}
                                pgaGuid={pgaDataValues[pgaDataValuesKey].pgaGuid || "FAKEGUID_"+pgaType}
                                expandAll={true}
                                formDisabled={formDisabled}
                                pgaProgram={""}//pga.pgaProgram}
                                pgaSubProgram={""}//pga.pgaSubProgram}
                                pgaType={pgaType}//pga.pgaProgram}
                                formType={pgaType}
                                FIELD_META={FIELD_META}
                                hsDataDtl_paramy={hsDataDtl}
                                updatePGAField={updatePGAField}
                                savePGAField={savePGAField}
                                updateMerchLineItemPgaObject={updateMerchLineItemPgaObject}
                                saveRepeatedField={saveRepeatedField}
                                updateRepeatedField={updateRepeatedField}
                                removeRepeatedGroup={removeRepeatedGroup}
                                addRepeatedItem={addRepeatedItem}
                                updateContainerPGA={updateContainerPGA}
                                addContainerPGA={addContainerPGA}
                                removeContainerPGA={removeContainerPGA}
                                saveContainerPGA={saveContainerPGA}
                                saveRepeatedSubField={saveRepeatedSubField}
                                updateRepeatedSubField={updateRepeatedSubField}
                                updateRepeatedSubSubField={updateRepeatedSubSubField}
                                saveRepeatedSubSubField={saveRepeatedSubSubField}
                                updateLaceyActField={updateLaceyActField}
                                saveLaceyActField={saveLaceyActField}
                                updatePGAItemField={updatePGAItemField}
                                savePGAItemField={savePGAItemField}
                                replaceAllRepeatedItem={replaceAllRepeatedItem}
                                deleteAndReplaceMultiplePGAValues={deleteAndReplaceMultiplePGAValues}
                                addRepeatedSubItem={addRepeatedSubField}
                                removeRepeatedSubGroup={removeRepeatedSubGroup}
                                />
                            }
                        {/* </div> */}
                    </div>
                )
            }
        }})  
        )
    }
     return ( 
           <>
            {formOpen && <div className="update-from-container">
                <div>
                    <div className="stepNumber" onClick={() => toggleExpandForm()}>
                        <Icon 
                        name={isOpen ? `minus circle`: `plus circle`}  >
                        
                        </Icon>
                        {!isEngine && <span>Update Form</span>}
                    </div>
                    {!isEngine && <>
                        <div className="update-close-icon" style={{ float:"right" }}>
                            <Icon  name="close" size="large" onClick={() => {
                                    toggleFormOn()
                                    selectedRowMethod("-2")
                                }} />
                        </div>
                        <div className="update-trash-icon" style={{ float:"right" }}>
                            <DeleteConfirmation message={<p>Are you sure you want to delete the item with Product Description: <b>{formData.productDescription}</b></p>} icon={"trash alternate"} toggleFormOn={toggleFormOn} delAPI={deleteAPI} productLineId={formData.productLineId} />
                        </div>
                    </>}
                    
                </div>
           {isOpen && <div className='entry-container'>
           <div id="tabContainer" className="ui grid tabContainer"><div className="main-body"><div className="test-info">
               <div className='entry-summary CBP_ES'>
           <div className={`es-section`}>
           <div className="formContentarea_bc">
            <div className=" esFormContainerii visible  ">
                <form autocomplete="off" className="ui form MerchandiseForm">
                    {!isEngine && <MerchandiseLineItem 
                            launchFrom = {"PRODUCT_HISTORY"}    
                            prodHistoryFormData = {formData}
                            updateFormState = {updateFormState}
                            dropdownValues={dropdownValues.eventMessage}
                            totalLineItems={1}
                            isDisabled = {() => {
                                return false
                            }}
                        />}
                        {isEngine && <div>
                            {Object.keys(pgaDropdownVal).map((programName, index) => {
                                return (
                                    <div>{programName}:
                                        <DropDown
                                            placeholder='select PGA Type'
                                            disabled={formDisabled}
                                            selection
                                            search
                                            className="parts-library-dropdown"
                                            onChange={(value) => {
                                                pgaDropdownOnChange({value, programName});
                                            }}
                                            text={selectedPga[programName] || "SELECT"}
                                            data={pgaDropdownVal[programName]}
                                        />
                                    </div>
                                )
                            })}

                        </div>}
                    <div>
                        {pgaItemRender(false)}
                    </div>
                    {isEngine && <>
                        <VoluntryPgas pgaDropdownOnChange={pgaDropdownOnChange} pgaWithoutPgaItems={pgaWithoutPgaItems} formDisabled={formDisabled} applicableProgramNames={applicableProgramNames} />
                        <div>
                            {pgaItemRender(true)}
                        </div> 
                    </>}
           <Button className="newButton primaryBtn btnType1 mediumBtn"
            id="saveFormProductHistory"
            type="button" 
            disabled={formDisabled}
            onClick={() => {
               // fromValidation()
               setIsSaving(true);
               let allPgaDataClone = cloneDeep(allPgaData);
               for(let onePga of _.get(allPgaData,"pgaData.pgaActData",[])){
                   for(let onePgaItem of _.get(onePga,"PGAItems",[])){
                       if(onePgaItem.regexx){
                            delete onePgaItem.regexx;
                       }

                   }
               }
               if(isEngine){
                    let flatPgaLists = makeFlatListForPgaItemsForProductHistory(dynamicProps);
                    let  newAllpgaData = mapFlatListWithAllPgaData(flatPgaLists, allPgaDataClone);
                    for(let onePga of _.get(newAllpgaData,"pgaData.pgaActData",[])){
                        for(let onePgaItem of _.get(onePga,"PGAItems",[])){
                            if(onePgaItem.regexx){
                                 delete onePgaItem.regexx;
                            }
     
                        }
                    }
                    window.parent.postMessage({allPgaData:newAllpgaData, currHtsIndex, currCountryIndex}, "*");
                    return;
                }
                // makeFlatListForPgaItemsForProductHistory(dynamicProps);
                newFormData["pgaData"] = allPgaData["pgaData"];
                newFormData["pgaFlags"] = allPgaData["pgaFlags"];
                updateAPI(newFormData)
                setTimeout(() => setIsSaving(false), 2000);
                // setIsOpen(false)
            }}>{isSaving ? "Saving..." : "Save"}</Button>
            {!isEngine && <Button id="resetFormProductHistory"
             className="newButton secondaryBtn btnType1 mediumBtn" type="button" onClick={() => {
               reset()
            }}>Reset</Button>}
            </form></div></div>
            </div></div>
            </div>

            </div></div></div>}
            </div>}
            </>
               
     );
}
 
export default UpdateFormUS;